import React, { useRef, useState } from "react";
import { motion } from "framer-motion";
import emailjs from "@emailjs/browser";
import { slideIn } from "../Components/Utilities/motion";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../Styles/Contact.css'

const Contact = () => {
  const formRef = useRef();
  const [form, setForm] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);

  const publicKey = process.env.REACT_APP_Email_Public_Key;
  
  const serviceId = process.env.REACT_APP_Email_Service_Id;

  const templateId = process.env.REACT_APP_Email_Template_Id;

  const handleNameChange = (e) => {
    const name = e.target.value;

    setForm({
      ...form,
      name: name,
    });
  };

  const handleEmailChange = (e) => {
    const email = e.target.value;
    setForm({
      ...form,
      email: email,
    });
  }

  const handleMessageChange = (e) => {
    const message = e.target.value;
    setForm({
      ...form,
      message: message,
    });
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    console.log("EMAIL " + process.env.REACT_APP_Email_Public_Key);

    emailjs.sendForm(
      serviceId ,
      templateId,
      formRef.current,
      { 
        publicKey
      },
    )
    .then(
      () => {
        setLoading(false);
        toast.success("Thank you. We will get back to you as soon as possible.");

        setForm({
          name: "",
          email: "",
          message: "",
        });
      },
      (error) => {
        setLoading(false);
        console.error(error);

        toast.error("Ahh, something went wrong. Please try again.");
      }
    );
  };

  return (
    <div className="contact-container" id="contact-us">
    <div
      className='max-w-screen-md pt-10 pb-20 bg-transparent contact-content-container'
    >
      <ToastContainer />
      <motion.div
        variants={slideIn("left", "tween", 0.2, 1)}
        initial="hidden"
        animate="show"
        className='bg-slate-900 p-8 rounded-3xl contact-motion-container'
      >
        <p className="text-white font-fugaz text-[2.5rem] sm:text-[3rem] lg:text-[4rem] contact-header">Get in touch</p>
        <form
          ref={formRef}
          onSubmit={handleSubmit}
          className='mt-4 flex flex-col gap-8'
        >
          <label className='flex flex-col'>
            <span className='text-white mb-4 contact-form-label'>Your Name</span>
            <input
              type='text'
              name='from_name'
              value={form.name}
              onChange={handleNameChange}
              placeholder="What's your good name?"
              className='bg-slate-800 placeholder:text-secondary text-white rounded-lg outline-none border-none contact-form-input'
              required
            />
          </label>
          <label className='flex flex-col'>
            <span className='text-white font-medium mb-4 contact-form-label'>Your email</span>
            <input
              type='email'
              name='from_email'
              value={form.email}
              onChange={handleEmailChange}
              placeholder="What's your web address?"
              className='bg-slate-800  placeholder:text-secondary text-white rounded-lg outline-none border-none contact-form-input'
              required
            />
          </label>
          <label className='flex flex-col'>
            <span className='text-white mb-4 contact-form-label'>Your Message</span>
            <textarea
              rows={7}
              name='message'
              value={form.message}
              onChange={handleMessageChange}
              placeholder='What you want to say?'
              className='bg-slate-800  placeholder:text-secondary text-white rounded-lg outline-none border-none contact-form-input'
              required
            />
          </label>

          <button
            type='submit'
            className='bg-slate-800 py-2.5 px-8 rounded-xl outline-none w-fit text-white font-bold shadow-md shadow-primary contact-btn'
          >
            {loading ? "Sending..." : "Send"}
          </button>
        </form>
      </motion.div>

      {/* <motion.div
        variants={slideIn("right", "tween", 0.2, 1)}
        className='xl:flex-1 xl:h-auto md:h-[550px] h-[350px]'
      >
        <EarthCanvas />
      </motion.div> */}
    </div>
    </div>
  );
};

export default Contact;
